import React from 'react';
import _ from 'lodash';
import { Card } from 'semantic-ui-react';
import {
	Sparklines,
	SparklinesLine,
	SparklinesReferenceLine
} from 'react-sparklines';

const average = data => _.round(_.sum(data) / data.length);

const WeatherChart = ({ data, color, title, units }) => {
	return (
		<Card centered>
			<Card.Content extra textAlign={'center'}>
				{title}
			</Card.Content>
			<Card.Content>
				<Sparklines height={256} width={512} data={data}>
					<SparklinesLine color={color} />
					<SparklinesReferenceLine type="avg" />
				</Sparklines>
			</Card.Content>
			<Card.Content extra textAlign="center">
				{average(data)} {units}
			</Card.Content>
		</Card>
	);
};

export default WeatherChart;



// WEBPACK FOOTER //
// ./src/components/WeatherChart.js